import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'

import './companyForm.scss'

import CompanyFormFieldsLayout from '../../../layouts/Company/CompanyForm/CompanyFormFieldsLayout'

class CompanyFormComponent extends React.Component {
    render() {
        const { handleSubmit, otherFields, initialValues, updateInvalid, isInvalid } = this.props;

        updateInvalid(isInvalid);

        return <Form onSubmit={handleSubmit}>
            <CompanyFormFieldsLayout otherFields={otherFields} platform={initialValues.platform} />
        </Form>;
    }
}

CompanyFormComponent.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    otherFields: PropTypes.object.isRequired,
    initialValues: PropTypes.object.isRequired,
    updateInvalid: PropTypes.func,
    isInvalid: PropTypes.bool,
}

export default CompanyFormComponent



// WEBPACK FOOTER //
// ./src/components/profile/Company/CompanyFormComponent.js